import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_REVISION: createAsyncMutation('GET_REVISION'),
    GET_REVISIONS: createAsyncMutation('GET_REVISIONS'),
}

const revision = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getRevision(store, payload) {
            let url = api.revision
            if (payload) {
                url += '?productCategoryId=' + payload.productCategoryId
                url += '&oemAddOn=' + payload.oemAddOn
                url += '&version=' + payload.version
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_REVISION })
        },
        getRevisions(store, payload) {
            let url = api.revision + 'GetRevisions'
            if (payload) {
                url += '?productCategoryId=' + payload.productCategoryId
                url += '&oemAddOn=' + payload.oemAddOn
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_REVISIONS })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default revision
